import { render, staticRenderFns } from "./GenerateLink.vue?vue&type=template&id=5bd069ba&scoped=true"
import script from "./GenerateLink.vue?vue&type=script&lang=js"
export * from "./GenerateLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd069ba",
  null
  
)

export default component.exports